import React from "react";
import {Form} from 'react-bootstrap';
import STCFormControl from "./STCForm.Control/STCForm.Control";
import STCFormCheck from "./STCForm.Check/STCForm.Check";
import STCFormGroup from "./STCForm.Group/STCForm.Group";
import STCFormLabel from "./STCForm.Label/STCForm.Label";
import STCFormSelect from "./STCForm.Select/STCForm.Select";
import STCFormText from "./STCForm.Text/STCForm.Text";
import STCFormFloatingLabel from "./STCForm.FloatingLabel/STCForm.FloatingLabel";

function STCForm(props){


    return(
        <Form
            style={props.style}
            className={props.className}
            ref={props.ref}
            as={props.as}
            validated={props.validated}
            onSubmit={props.onSubmit}
            onReset={props.onReset}
        >
            {props.children}
        </Form>
    )

}

STCForm.Check = STCFormCheck;
STCForm.Control = STCFormControl;
STCForm.Group = STCFormGroup;
STCForm.Label = STCFormLabel;
STCForm.FloatingLabel = STCFormFloatingLabel;
STCForm.Select = STCFormSelect;
STCForm.Text = STCFormText;

export default STCForm;